// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__1Q87r","loadingPage":"style_loadingPage__3k4xc"};